<script>
import config from '@/config/global.config'
export default {
  name: 'Heap',
  data () {
    return {
    }
  },

  methods: {
    setZywaveAnalyticsProperties() {
      let self = this
          document.body.querySelector("zywave-analytics").userProperties = {
            givenName: self.$store.state.auth.user.name,
            familyName: self.$store.state.auth.user.name,
            email: self.$store.state.auth.user.username,
            agencyMatrixEmployeeId: self.$store.state.auth.user.id,
            agencyMatrixMasterId: self.$store.state.auth.config.id,
            agencyMatrixOfficeId: self.$store.state.auth.location.office.id,
            agencyMatrixEmployeeName: self.$store.state.auth.user.name,
            agencyMatrixEmployeeUsername: self.$store.state.auth.user.username,
            agencyMatrixEmployeeType: self.$store.state.auth.permissions.employeeType || '',
            agencyMatrixEmployeeSubType: self.$store.state.auth.permissions.employeeSubType || 0,
            agencyMatrixEmployeeIsAdmin: self.$store.state.auth.permissions.PRadmin
      }
    }
  },

  mounted() {
    let zywaveToolKit = document.createElement('script')
    zywaveToolKit.setAttribute('type', 'module')
    zywaveToolKit.setAttribute('src', 'https://cdn.zywave.com/@zywave/zywave-api-toolkit-bundle@latest/dist/bundle.js')

    let zywaveAnalytics = document.createElement('zywave-analytics')
    zywaveAnalytics.setAttribute('appcues-account-id', config.appcuesAppId())
    zywaveAnalytics.setAttribute('heap-app-id', config.heapAppId())

    let self = this

    document.onreadystatechange = () => {
      if (document.readyState == 'complete') {
        zywaveAnalytics.setAttribute('identity','AM-' + self.$store.state.auth.user.id)

        document.body.appendChild(zywaveToolKit)
        document.body.appendChild(zywaveAnalytics)

        self.setZywaveAnalyticsProperties()
      }
    }
  }
}
</script>
